var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsquerda({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.896437 4.25932L5.94394 0.455548C7.42185 -0.658941 9.53777 0.398992 9.53777 2.2484V9.84795C9.53777 11.6974 7.42185 12.7553 5.94394 11.6408L0.896437 7.83703C-0.298812 6.9406 -0.298812 5.14772 0.896437 4.25128V4.25932Z",
    fill: "#FF6600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsquerda);
export default __webpack_public_path__ + "static/media/Esquerda.935f9813b5355d85bdb69053d1c89c72.svg";
export { ForwardRef as ReactComponent };